<template>
  <div id="aboutUs">
    <Header></Header>
    <div class="imgdiv">
      <img class="img" src="@/assets/img/aboutUs.jpg" width="100%">
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/header/Header";
import Footer from "@/components/footer/Footer";
export default {
  name: "aboutUs",
  components:{
    Footer,
    Header
  },
  data(){
    return {
      imgSrc:''
    }
  }

}
</script>

<style scoped>
#aboutUs{
  width: 100%;
  height: auto;
}
.imgdiv{
  width: 1920px;height: 599px;border: 1px solid darkblue;
}
.img{
  width: 1124px;
  height: 599px;
  text-align: center;
  margin: 0 auto;
}

</style>